import React from 'react';
import { useFieldProps } from '../../../contexts/field-props-context';
import { type PublicFileUploadProps } from '../../../types/public-props';
import { Field } from '../../../headless/field';

interface ErrorFileUploadProps {
  asChild?: boolean;
  className?: string;
}

export const Error = React.forwardRef<HTMLDivElement, ErrorFileUploadProps>(
  (props, ref) => {
    const { errorMessage } = useFieldProps<PublicFileUploadProps>();

    return (
      <Field.Error ref={ref} {...props}>
        {errorMessage}
      </Field.Error>
    );
  },
);

Error.displayName = 'FileUpload.Error';
